import React, { useState } from 'react';

import { ImClock } from "react-icons/im"
// Simple Clock for display the current local time.


const Clock = () => {

    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    let time = new Date().toLocaleTimeString()
    let date = new Date().toLocaleDateString("en-US", options)
    const [currentTime, setCurrentTime] = useState(time);

    const updateTime = () => {
        time = new Date().toLocaleTimeString()
        setCurrentTime(time)
    }
    // increment up by 1 second each time 
    setInterval(updateTime, 1000)

    return (<>
        <div className='container mb-3 p-4'>
            <h1 className="text-center text-2xl text-kombuGreen font-semibold lg:text-4xl">{`${date} - ${currentTime}`}</h1>
        </div>
    </>);
}

export default Clock;